export const STORAGE_PREFIX = 'coretas:';

export const namespacedStorageKey = (key: string): string =>
  `${STORAGE_PREFIX}${key}`;

export const COPILOT_STORAGE_KEYS = {
  openTabs: 'copilot.openTabs',
  activeThreadId: 'copilot.activeThreadId',
} as const;

// Suffixed with the export key: a draft saved from this device is not offered again.
export const GMAIL_STORAGE_KEYS = {
  draftSaved: 'gmail.draftSaved',
} as const;

// Tabs acting in different organizations must not overwrite each other's copy.
export const organizationScopedKey = (
  key: string,
  organizationId: number | null | undefined,
): string => (organizationId == null ? key : `${key}.${organizationId}`);

// Suffixed with the strategy id: the intro this viewer last printed on that plan.
export const MEDIA_PLAN_PDF_STORAGE_KEYS = {
  intro: 'mediaPlanPdf.intro',
} as const;

// Suffixed with `<platform>_<report_type>`: the optional metric columns this viewer shows.
export const NATIVE_REPORT_STORAGE_KEYS = {
  optionalMetrics: 'nativeReport.optionalMetrics',
} as const;

// Persisted UI state the next identity must not inherit, in every organization it was keyed by.
export const IDENTITY_SCOPED_STORAGE_KEYS: readonly string[] = [
  COPILOT_STORAGE_KEYS.openTabs,
  COPILOT_STORAGE_KEYS.activeThreadId,
  GMAIL_STORAGE_KEYS.draftSaved,
  MEDIA_PLAN_PDF_STORAGE_KEYS.intro,
];

// Written on every identity change; other tabs observe it via `storage`.
export const IDENTITY_CHANGE_STORAGE_KEY =
  namespacedStorageKey('identity-change');

// sessionStorage: the agency import a tab follows, per agency and user.
export const AGENCY_ONBOARDING_RUN_KEY = namespacedStorageKey(
  'agency-onboarding-run',
);

// sessionStorage: the auth screens' address, kept out of the URL so analytics never sees it.
export const AUTH_EMAIL_STORAGE_KEY = namespacedStorageKey('auth-email');

// sessionStorage: the signup's brand-or-agency choice, so a return to /signup cannot re-kind the trial.
export const SIGNUP_KIND_STORAGE_KEY = namespacedStorageKey('signup-kind');

// sessionStorage: a phone that chose to connect anyway, so an OAuth round-trip skips the laptop prompt.
export const CONNECT_ON_MOBILE_STORAGE_KEY =
  namespacedStorageKey('connect-on-mobile');

// sessionStorage: the organization this tab acts in, so two tabs can hold two clients.
export const TAB_ORGANIZATION_STORAGE_KEY =
  namespacedStorageKey('tab-organization');

// sessionStorage: why the last load left a workspace, shown once after the reload.
export const ORGANIZATION_UNAVAILABLE_NOTICE_KEY = namespacedStorageKey(
  'organization-unavailable',
);

// sessionStorage: the organization a link named, held across the login it may need; identity resets keep it.
export const LINKED_ORGANIZATION_STORAGE_KEY = namespacedStorageKey(
  'linked-organization',
);

// sessionStorage: the organization a link just switched this tab to, announced once after the load.
export const ORGANIZATION_ARRIVAL_STORAGE_KEY = namespacedStorageKey(
  'organization-arrival',
);
